import { FC } from 'react';

import { PlusIcon } from '../../../../../assets/icons/index';
import { PlusIconVariant } from '../../../../../assets/icons/plus-icon';
import bustsInSilhouette from '../../../../../assets/images/busts-in-silhouette.png';
import { AppFormattedMessage } from '../../../../../components/app-formatted-message/index';
import Button from '../../../../../components/button/index';

export const InternalEmptyState: FC<{ onAddStakeholder: () => void }> = ({ onAddStakeholder }) => (
  <div className="flex w-full flex-1 flex-col items-center justify-center py-10">
    <div className="centered flex w-[393.33px] flex-col items-center justify-center gap-6 rounded-2xl border border-[rgba(146,146,146,0.5)] px-6 py-8">
      <div className="flex flex-col items-center gap-10">
        <div
          className="rounded-full bg-white p-3"
          style={{ boxShadow: '0px 0px 8px 0px rgba(48, 39, 58, 0.13) inset' }}
        >
          <div
            className="centered flex size-28 items-center gap-3 rounded-full"
            style={{
              background:
                'linear-gradient(180deg, rgba(101, 32, 175, 0.13) 0%, rgba(44, 38, 50, 0.13) 100%)',
            }}
          >
            <div className="size-[56px] object-cover">
              <img alt="" src={bustsInSilhouette} />
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center gap-2">
          <p className="text-xl font-semibold leading-8 text-gray-700">
            <AppFormattedMessage id="NO_STAKEHOLDERS_YET" />
          </p>
          <p className="text-center text-xs font-medium leading-[18px] text-gray-500">
            <AppFormattedMessage id="ADD_STAKEHOLDERS_TO_SHARE_WITH_THEM" />
          </p>
        </div>
      </div>
      <Button
        className="h-9 w-fit gap-1 py-1.5 pl-3 pr-4"
        data-permission-required
        onClick={onAddStakeholder}
        type="button"
      >
        <PlusIcon className="size-5" iconColor="#ffffff" variant={PlusIconVariant.VAULT} />
        <AppFormattedMessage id="ADD_STAKEHOLDER_ACTION" />
      </Button>
    </div>
  </div>
);
